import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { ShipmentImage } from '../../../interfaces/ShipmentImage/ShipmentImage';
import { ShipmentImages } from './ShipmentImages';
import { sharedStyles } from '../../../utils/Style';

type ShipmentImagesDialogProps = {
  images: ShipmentImage[];
  open: boolean;
  onClose: () => void;
};

export const ShipmentImagesDialog = ({
  images,
  open,
  onClose,
}: ShipmentImagesDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <ShipmentImages images={images} isReadOnly loading={false} />
      </DialogContent>

      <DialogActions>
        <Button
          variant='contained'
          color='inherit'
          onClick={onClose}
          sx={sharedStyles.buttonText}
        >
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
};
